function initMap() {
  var infoWindow;
  var markerImageUrl = '/images/maps/map-marker.png';
  var markerImage = new google.maps.MarkerImage(markerImageUrl,
    new google.maps.Size(36, 48));

  var map = new google.maps.Map(document.getElementById('findsGoogleMap'), {
    zoom: 3,
    center: {lat: -28.024, lng: 140.887},
    styles: mapStyle
  });

  // Create an array of alphabetical characters used to label the markers.
  var labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

  // Add some markers to the map.
  // Note: The code uses the JavaScript Array.prototype.map() method to
  // create an array of markers based on a given "locations" array.
  // The map() method here has nothing to do with the Google Maps API.
  var markers = locations.map(function(location, i) {

    return new google.maps.Marker({
      position: location,
      icon: markerImage,
      label: {text: labels[i % labels.length], color: '#ffffff'}
    });
  });


  var markerCluserStyles = [
    {
      textColor: 'white',
      url: '/images/maps/m1.png',
      height: 53,
      width: 53
    },
    {
      textColor: 'white',
      url: '/images/maps/m2.png',
      height: 53,
      width: 53
    },
    {
      textColor: 'white',
      url: '/images/maps/m3.png',
      height: 53,
      width: 53
    },
    {
      textColor: 'white',
      url: '/images/maps/m4.png',
      height: 53,
      width: 53
    },
    {
      textColor: 'white',
      url: '/images/maps/m5.png',
      height: 53,
      width: 53
    }
  ]
  // Add a marker clusterer to manage the markers.
  var markerCluster = new MarkerClusterer(map, markers,
            {
              imagePath: 'images/maps/m',
              styles: markerCluserStyles
            });

}

var mapStyle = [
    {
        'featureType': 'all',
        'elementType': 'all',
        'stylers': [
            {
                'visibility': 'on'
            }
        ]
    },
    {
        'featureType': 'all',
        'elementType': 'labels',
        'stylers': [
            {
                'visibility': 'off'
            },
            {
                'saturation': '-100'
            }
        ]
    },
    {
        'featureType': 'all',
        'elementType': 'labels.text.fill',
        'stylers': [
            {
                'saturation': 36
            },
            {
                'color': '#000000'
            },
            {
                'lightness': 40
            },
            {
                'visibility': 'off'
            }
        ]
    },
    {
        'featureType': 'all',
        'elementType': 'labels.text.stroke',
        'stylers': [
            {
                'visibility': 'off'
            },
            {
                'color': '#000000'
            },
            {
                'lightness': 16
            }
        ]
    },
    {
        'featureType': 'all',
        'elementType': 'labels.icon',
        'stylers': [
            {
                'visibility': 'off'
            }
        ]
    },
    {
        'featureType': 'administrative',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#000000'
            },
            {
                'lightness': 20
            }
        ]
    },
    {
        'featureType': 'administrative',
        'elementType': 'geometry.stroke',
        'stylers': [
            {
                'color': '#000000'
            },
            {
                'lightness': 17
            },
            {
                'weight': 1.2
            }
        ]
    },
    {
        'featureType': 'landscape',
        'elementType': 'geometry',
        'stylers': [
            {
                'color': '#000000'
            },
            {
                'lightness': 20
            }
        ]
    },
    {
        'featureType': 'landscape',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#4d6059'
            }
        ]
    },
    {
        'featureType': 'landscape',
        'elementType': 'geometry.stroke',
        'stylers': [
            {
                'color': '#4d6059'
            }
        ]
    },
    {
        'featureType': 'landscape.natural',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#4d6059'
            }
        ]
    },
    {
        'featureType': 'poi',
        'elementType': 'geometry',
        'stylers': [
            {
                'lightness': 21
            }
        ]
    },
    {
        'featureType': 'poi',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#4d6059'
            }
        ]
    },
    {
        'featureType': 'poi',
        'elementType': 'geometry.stroke',
        'stylers': [
            {
                'color': '#4d6059'
            }
        ]
    },
    {
        'featureType': 'road',
        'elementType': 'geometry',
        'stylers': [
            {
                'visibility': 'on'
            },
            {
                'color': '#7f8d89'
            }
        ]
    },
    {
        'featureType': 'road',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#7f8d89'
            }
        ]
    },
    {
        'featureType': 'road.highway',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#7f8d89'
            },
            {
                'lightness': 17
            }
        ]
    },
    {
        'featureType': 'road.highway',
        'elementType': 'geometry.stroke',
        'stylers': [
            {
                'color': '#7f8d89'
            },
            {
                'lightness': 29
            },
            {
                'weight': 0.2
            }
        ]
    },
    {
        'featureType': 'road.arterial',
        'elementType': 'geometry',
        'stylers': [
            {
                'color': '#000000'
            },
            {
                'lightness': 18
            }
        ]
    },
    {
        'featureType': 'road.arterial',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#7f8d89'
            }
        ]
    },
    {
        'featureType': 'road.arterial',
        'elementType': 'geometry.stroke',
        'stylers': [
            {
                'color': '#7f8d89'
            }
        ]
    },
    {
        'featureType': 'road.local',
        'elementType': 'geometry',
        'stylers': [
            {
                'color': '#000000'
            },
            {
                'lightness': 16
            }
        ]
    },
    {
        'featureType': 'road.local',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#7f8d89'
            }
        ]
    },
    {
        'featureType': 'road.local',
        'elementType': 'geometry.stroke',
        'stylers': [
            {
                'color': '#7f8d89'
            }
        ]
    },
    {
        'featureType': 'transit',
        'elementType': 'geometry',
        'stylers': [
            {
                'color': '#000000'
            },
            {
                'lightness': 19
            }
        ]
    },
    {
        'featureType': 'water',
        'elementType': 'all',
        'stylers': [
            {
                'color': '#2b3638'
            },
            {
                'visibility': 'on'
            }
        ]
    },
    {
        'featureType': 'water',
        'elementType': 'geometry',
        'stylers': [
            {
                'color': '#2b3638'
            },
            {
                'lightness': 17
            }
        ]
    },
    {
        'featureType': 'water',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#24282b'
            }
        ]
    },
    {
        'featureType': 'water',
        'elementType': 'geometry.stroke',
        'stylers': [
            {
                'color': '#24282b'
            }
        ]
    },
    {
        'featureType': 'water',
        'elementType': 'labels',
        'stylers': [
            {
                'visibility': 'off'
            }
        ]
    },
    {
        'featureType': 'water',
        'elementType': 'labels.text',
        'stylers': [
            {
                'visibility': 'off'
            }
        ]
    },
    {
        'featureType': 'water',
        'elementType': 'labels.text.fill',
        'stylers': [
            {
                'visibility': 'off'
            }
        ]
    },
    {
        'featureType': 'water',
        'elementType': 'labels.text.stroke',
        'stylers': [
            {
                'visibility': 'off'
            }
        ]
    },
    {
        'featureType': 'water',
        'elementType': 'labels.icon',
        'stylers': [
            {
                'visibility': 'off'
            }
        ]
    }
]

var locations = [
  {lat: -31.563910, lng: 147.154312},
  {lat: -33.718234, lng: 150.363181},
  {lat: -33.727111, lng: 150.371124},
  {lat: -33.848588, lng: 151.209834},
  {lat: -33.851702, lng: 151.216968},
  {lat: -34.671264, lng: 150.863657},
  {lat: -35.304724, lng: 148.662905},
  {lat: -36.817685, lng: 175.699196},
  {lat: -36.828611, lng: 175.790222},
  {lat: -37.750000, lng: 145.116667},
  {lat: -37.759859, lng: 145.128708},
  {lat: -37.765015, lng: 145.133858},
  {lat: -37.770104, lng: 145.143299},
  {lat: -37.773700, lng: 145.145187},
  {lat: -37.774785, lng: 145.137978},
  {lat: -37.819616, lng: 144.968119},
  {lat: -38.330766, lng: 144.695692},
  {lat: -39.927193, lng: 175.053218},
  {lat: -41.330162, lng: 174.865694},
  {lat: -42.734358, lng: 147.439506},
  {lat: -42.734358, lng: 147.501315},
  {lat: -42.735258, lng: 147.438000},
  {lat: -43.999792, lng: 170.463352}
]

$(function() {

  /* ALLOW ESC KEY TO CLOSE MENUS */
  $(document).keyup(function(e) {
    if (e.keyCode == 27) { // escape key maps to keycode `27`
      $('.navbar-toggler').addClass('collapsed');
      $('.navbar-collapse').removeClass('show');
    }
  });



  var navOffset = 48;
  var win = $(window);



  win.scroll(function(){
    if ($(document).scrollTop() > 48) {
      // animate fixed div to small size:
      $('.logo-expanded').addClass('hide');
    } else {
      //  animate fixed div to original size
      $('.logo-expanded').removeClass('hide');
    }
  });

  $('.gallery-link').on('click', this, function(e) {
    e.preventDefault();

    if( $(this).hasClass('gallery-thumb') ) {
      var oldMainImage = $('.image-gallery').find('.gallery-main-image').attr('src');
      var newMainImage = $(this).find('.gallery-thumb-image').attr('src');

      $('.gallery-main-image')
        .fadeTo(200, 0.30, function() {
          $(this).attr('src', newMainImage);
        })
        .fadeTo(200, 1);


      $(this).find('.gallery-thumb-image')
        .fadeTo(200, 0.30, function() {
          $(this).attr('src', oldMainImage);
        })
        .fadeTo(200, 1);

    }
  });

  $('.swatch-link').on('click', this, function(e) {
    e.preventDefault();
    var image = $(this).children('.swatch-thumb-image');
    var fullimage = image.data('fullimage');
    var targetid = image.data('targetid');

    $('#'+targetid+' img')
      .fadeTo(200, 0.30, function() {
        $(this).attr('src', fullimage);
      })
      .fadeTo(200, 1);

  });

  $('.image-swapper-link').on('click mouseover', this, function(e) {
    e.preventDefault();
    $('.image-swapper-link').removeClass('active');
    $(this).addClass('active');
    var image = $(this).find('.image-swapper-src');
    var newimagesrc = image.data('fullimage');
    var targetid = image.data('targetid');
    var targetimage = $('#'+targetid+' img');
    var currentsrc = targetimage.attr('src');
    if(newimagesrc != currentsrc) {
      targetimage.attr('data-currentsrc', newimagesrc);

      targetimage.stop(true, true).fadeTo(100, 0.30, function() {
          $(this).attr('src', newimagesrc);
        }).stop(true, true).fadeTo(100, 1);
      }
  });

  // $('.image-swapper-link').on('mouseover', this, function(e) {
  //   var newimage = $(this).find('.image-swapper-src');
  //   var newimagesrc = newimage.data('fullimage');
  //   var targetid = newimage.data('targetid');
  //   var targetimage = $('#'+targetid+' img');
  //   var currentsrc = targetimage.attr('src');
  //   if(newimagesrc != currentsrc) {
  //     targetimage.attr('data-currentsrc', currentsrc);
  //     targetimage.stop(true, true).fadeTo(100, 0.30, function() {
  //         $(this).attr('src', newimagesrc);
  //       }).stop(true, true).fadeTo(100, 1);
  //   }
  // });
  //
  // $('.image-swapper-link').on('mouseout', this, function(e) {
  //   var newimage = $(this).find('.image-swapper-src');
  //   var newimagesrc = newimage.data('fullimage');
  //   var targetid = newimage.data('targetid');
  //   var targetimage = $('#'+targetid+' img');
  //   var currentsrc = targetimage.attr('data-currentsrc');
  //   if(newimagesrc != currentsrc) {
  //     targetimage.stop(true, true).fadeTo(100, 0.30, function() {
  //         $(this).attr('src', currentsrc);
  //       }).stop(true, true).fadeTo(100, 1);
  //   }
  // });



  function filterPath(string) {
    return string
      .replace(/^\//, '')
      .replace(/(index|default).[a-zA-Z]{3,4}$/, '')
      .replace(/\/$/, '');
  }

  var locationPath = filterPath(location.pathname);
  $('a.ss[href*=\\#]:not([href=\\#])').each(function () {
    var thisPath = filterPath(this.pathname) || locationPath;
    var hash = this.hash;
    if ($('#' + hash.replace(/#/, '')).length) {
      if (locationPath == thisPath && (location.hostname == this.hostname || !this.hostname) && this.hash.replace(/#/, '')) {
        var $target = $(hash), target = this.hash;
        if (target) {
          $(this).click(function (event) {
            event.preventDefault();
            $('html, body').animate({scrollTop: $target.offset().top - navOffset }, 700, function () {
              // location.hash = target;
              // $target.focus();
              if ($target.is(':focus')){ //checking if the target was focused
                return false;
              } else {
                $target.attr('tabindex','-1'); //Adding tabindex for elements not focusable
                // $target.focus(); //Setting focus
              };
            });
          });
        }
      }
    }
  });
  if(window.location.hash) {
    // smooth scroll to the anchor id
    $('html, body').animate({
      scrollTop: $(window.location.hash).offset().top - navOffset
    }, 700);
  }






});
